import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  setConfirmation,
  setMarket,
  setRunner,
  setIsBack,
  setPrice,
  setPriceActual,
  setStake,
  setDelay,
  setShowBetPlacingPopover,
  setBetPlacingPopoverStage,
  setMarketType,
  setMarketName,
  setFancyPrice,
  setIsCashOut,
  setIsSubmitting,
} from "../../store/betPlacing/betPlacing.slice";
import {
  requestHROrder,
  requestSetFancyOrder,
  requestSetOrder,
} from "../../store/betPlacing/betPlacing.thunks";
import { setLoginNew } from "../../store/LoginNew/loginNew.slice";
import { requestStakeButtons } from "../../store/stakes/stakes.thunks";
import { requestUpdateStakeButtons } from "../../store/stakes/stakes.thunks";
import { requestOpenBets } from "../../store/openBets/openBets.thunks";
import { requestUnMatchedBets } from "../../store/unMatchedBets/unMatchedBets.thunks";
import { requestBalance } from "../../store/balance/balance.thunks";
import { requestSportStart } from "../../store/eventPage/eventPage.thunks";

export const connectBetPlacing = (wrappedProps) => (component) => {
  function mapStateToProps(state) {
    return {
      betPlacing: state.betPlacing,
      presetStakeSettings: state.user.settings.presetStakeSettings,
      oneClick: state.user.settings.oneClickSettings.active,
      sportEvent: state.sportEvent,
      auth: state.auth,
      messages: state.message,
      notifications: state.user.settings.notifications,
      stakes: state.stakes,
      user: state.user,
    };
  }


  function mapDispatchToProps(dispatch) {
    const actions = {
      requestSetOrder,
      requestSportStart,
      requestSetFancyOrder,
      requestOpenBets,
      requestUnMatchedBets,
      requestHROrder,
      setConfirmation,
      setMarket,
      setRunner,
      setIsBack,
      setPrice,
      setPriceActual,
      setDelay,
      setStake,
      setShowBetPlacingPopover,
      setBetPlacingPopoverStage,
      setLoginNew,
      setMarketType,
      setMarketName,
      setFancyPrice,
      setIsCashOut,
      setIsSubmitting,
      requestStakeButtons,
      requestUpdateStakeButtons,
      requestBalance,
    };

    return { actions: bindActionCreators(actions, dispatch) };
  }

  return connect(mapStateToProps, mapDispatchToProps)(component);
};
